import gql from 'graphql-tag';

export const COOKIE_POLICY_QUERY = gql`
  query getSuperContentByUrl($url: String!) {
    SuperContent(Url: $url) {
      Id
      Url
      IxName
      Title
      Text
    }
  }
`;

export const COOKIE_POLICY_VARIABLES = {
  url: '/radyod-cerez-politikasi',
};
